// @flow
import { useDispatch } from 'react-redux';

import { createPrepaid, fetchPrepaid, replacePrepaid } from '@gandi/billing';
import type { Currency } from '@gandi/billing';

export function useCurrencySync({
  currency,
  currencyState,
}: {
  currency?: Currency,
  currencyState?: Currency,
}): { syncCurrency: (sharingId: string) => Promise<void> } {
  const dispatch = useDispatch();

  const syncCurrency = async (sharingId: string) => {
    if (!currency) return;

    if (!currencyState) {
      await dispatch(
        createPrepaid({ currency, optimistic: true }, { sharingId }),
      );
      // $FlowFixMe[incompatible-call]
      await dispatch(fetchPrepaid(sharingId));
    } else if (currency !== currencyState) {
      await dispatch(replacePrepaid({ currency }, { sharingId }));
      // $FlowFixMe[incompatible-call]
      await dispatch(fetchPrepaid(sharingId));
    }
  };

  return { syncCurrency };
}
